import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../ctaButton/ctaButton';
import ModalPopup from '../modalPopup/modalPopup';
import styles from './extensionCta.module.scss';

export default function ExtensionCta({
  label,
  browserExtensions,
  lightBoxMessages,
  variant,
  color,
}) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [ctaUrl, setCtaUrl] = React.useState('');
  const [lightBoxText, setLightBoxText] = useState(
    lightBoxMessages.lightBoxTextGeneral
  );
  useEffect(() => {
    const ua = window.navigator.userAgent;

    if (ua.includes('Chrome')) {
      if (browserExtensions.chrome) {
        setCtaUrl(browserExtensions.chrome);
      } else if (lightBoxMessages.lightBoxTextChrome) {
        setLightBoxText(lightBoxMessages.lightBoxTextChrome);
      }
    } else if (ua.includes('Mozilla')) {
      if (browserExtensions.firefox) {
        setCtaUrl(browserExtensions.firefox);
      } else if (lightBoxMessages.lightBoxTextFirefox) {
        setLightBoxText(lightBoxMessages.lightBoxTextFirefox);
      }
    } else if (ua.includes('Edge')) {
      if (browserExtensions.edge) {
        setCtaUrl(browserExtensions.edge);
      } else if (lightBoxMessages.lightBoxTextEdge) {
        setLightBoxText(lightBoxMessages.lightBoxTextEdge);
      }
    } else if (ua.includes('Safari')) {
      if (browserExtensions.safari) {
        setCtaUrl(browserExtensions.safari);
      } else if (lightBoxMessages.lightBoxTextSafari) {
        setLightBoxText(lightBoxMessages.lightBoxTextSafari);
      }
    } else {
      setLightBoxText(lightBoxMessages.lightBoxTextGeneral);
    }
  }, [browserExtensions, lightBoxMessages]);

  const onExtensionClick = () => {
    if (ctaUrl) {
      const urlParams = new URLSearchParams(window.location.search);
      const utmParamArr = [];
      if (urlParams.has('utm_source')) {
        utmParamArr.push(`utm_source=${urlParams.get('utm_source')}`);
      }
      if (urlParams.has('utm_medium')) {
        utmParamArr.push(`utm_medium=${urlParams.get('utm_medium')}`);
      }
      if (urlParams.has('utm_campaignid')) {
        utmParamArr.push(`utm_campaignid=${urlParams.get('utm_campaignid')}`);
      }
      const utmParamsStr = `${parse(ctaUrl)}%28${encodeURIComponent(
        utmParamArr.join('&')
      )}%29`;
      window.location.assign(utmParamsStr);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <div className={styles.main}>
      <div className={styles.ctaContainer}>
        <CtaButton
          aria-label="Read More Reviews "
          label={label}
          variant={variant || 'solid'}
          color={color}
          data-testid="extension"
          className={styles.cta}
          onClick={onExtensionClick}
        />
      </div>
      <ModalPopup isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="modal-popup">{parse(`${lightBoxText}`)}</div>
      </ModalPopup>
    </div>
  );
}
ExtensionCta.defaultProps = {
  label: null,
  browserExtensions: {},
  lightBoxMessages: {},
};

ExtensionCta.propTypes = {
  label: PropTypes.string,
  browserExtensions: PropTypes.shape({
    chrome: PropTypes.string,
    safari: PropTypes.string,
    edge: PropTypes.string,
    firefox: PropTypes.string,
  }),
  lightBoxMessages: PropTypes.shape({
    lightBoxTextGeneral: PropTypes.string,
    lightBoxTextSafari: PropTypes.string,
    lightBoxTextEdge: PropTypes.string,
    lightBoxTextChrome: PropTypes.string,
    lightBoxTextFirefox: PropTypes.string,
  }),
};
